/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ZeroTrustSecurityRouteImport } from './routes/ZeroTrustSecurity'
import { Route as WinFormModernRouteImport } from './routes/WinFormModern'
import { Route as SiteHitsRouteImport } from './routes/SiteHits'
import { Route as SaasScalabilityRouteImport } from './routes/SaasScalability'
import { Route as PortfolioRouteImport } from './routes/Portfolio'
import { Route as InfraAutomationRouteImport } from './routes/InfraAutomation'
import { Route as HomeRouteImport } from './routes/Home'
import { Route as ErpProjectRouteImport } from './routes/ErpProject'
import { Route as BlogRouteImport } from './routes/Blog'
import { Route as IndexRouteImport } from './routes/index'

const ZeroTrustSecurityRoute = ZeroTrustSecurityRouteImport.update({
  id: '/ZeroTrustSecurity',
  path: '/ZeroTrustSecurity',
  getParentRoute: () => rootRouteImport,
} as any)
const WinFormModernRoute = WinFormModernRouteImport.update({
  id: '/WinFormModern',
  path: '/WinFormModern',
  getParentRoute: () => rootRouteImport,
} as any)
const SiteHitsRoute = SiteHitsRouteImport.update({
  id: '/SiteHits',
  path: '/SiteHits',
  getParentRoute: () => rootRouteImport,
} as any)
const SaasScalabilityRoute = SaasScalabilityRouteImport.update({
  id: '/SaasScalability',
  path: '/SaasScalability',
  getParentRoute: () => rootRouteImport,
} as any)
const PortfolioRoute = PortfolioRouteImport.update({
  id: '/Portfolio',
  path: '/Portfolio',
  getParentRoute: () => rootRouteImport,
} as any)
const InfraAutomationRoute = InfraAutomationRouteImport.update({
  id: '/InfraAutomation',
  path: '/InfraAutomation',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRoute = HomeRouteImport.update({
  id: '/Home',
  path: '/Home',
  getParentRoute: () => rootRouteImport,
} as any)
const ErpProjectRoute = ErpProjectRouteImport.update({
  id: '/ErpProject',
  path: '/ErpProject',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogRoute = BlogRouteImport.update({
  id: '/Blog',
  path: '/Blog',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/Blog': typeof BlogRoute
  '/ErpProject': typeof ErpProjectRoute
  '/Home': typeof HomeRoute
  '/InfraAutomation': typeof InfraAutomationRoute
  '/Portfolio': typeof PortfolioRoute
  '/SaasScalability': typeof SaasScalabilityRoute
  '/SiteHits': typeof SiteHitsRoute
  '/WinFormModern': typeof WinFormModernRoute
  '/ZeroTrustSecurity': typeof ZeroTrustSecurityRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/Blog': typeof BlogRoute
  '/ErpProject': typeof ErpProjectRoute
  '/Home': typeof HomeRoute
  '/InfraAutomation': typeof InfraAutomationRoute
  '/Portfolio': typeof PortfolioRoute
  '/SaasScalability': typeof SaasScalabilityRoute
  '/SiteHits': typeof SiteHitsRoute
  '/WinFormModern': typeof WinFormModernRoute
  '/ZeroTrustSecurity': typeof ZeroTrustSecurityRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/Blog': typeof BlogRoute
  '/ErpProject': typeof ErpProjectRoute
  '/Home': typeof HomeRoute
  '/InfraAutomation': typeof InfraAutomationRoute
  '/Portfolio': typeof PortfolioRoute
  '/SaasScalability': typeof SaasScalabilityRoute
  '/SiteHits': typeof SiteHitsRoute
  '/WinFormModern': typeof WinFormModernRoute
  '/ZeroTrustSecurity': typeof ZeroTrustSecurityRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/Blog'
    | '/ErpProject'
    | '/Home'
    | '/InfraAutomation'
    | '/Portfolio'
    | '/SaasScalability'
    | '/SiteHits'
    | '/WinFormModern'
    | '/ZeroTrustSecurity'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/Blog'
    | '/ErpProject'
    | '/Home'
    | '/InfraAutomation'
    | '/Portfolio'
    | '/SaasScalability'
    | '/SiteHits'
    | '/WinFormModern'
    | '/ZeroTrustSecurity'
  id:
    | '__root__'
    | '/'
    | '/Blog'
    | '/ErpProject'
    | '/Home'
    | '/InfraAutomation'
    | '/Portfolio'
    | '/SaasScalability'
    | '/SiteHits'
    | '/WinFormModern'
    | '/ZeroTrustSecurity'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BlogRoute: typeof BlogRoute
  ErpProjectRoute: typeof ErpProjectRoute
  HomeRoute: typeof HomeRoute
  InfraAutomationRoute: typeof InfraAutomationRoute
  PortfolioRoute: typeof PortfolioRoute
  SaasScalabilityRoute: typeof SaasScalabilityRoute
  SiteHitsRoute: typeof SiteHitsRoute
  WinFormModernRoute: typeof WinFormModernRoute
  ZeroTrustSecurityRoute: typeof ZeroTrustSecurityRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/ZeroTrustSecurity': {
      id: '/ZeroTrustSecurity'
      path: '/ZeroTrustSecurity'
      fullPath: '/ZeroTrustSecurity'
      preLoaderRoute: typeof ZeroTrustSecurityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/WinFormModern': {
      id: '/WinFormModern'
      path: '/WinFormModern'
      fullPath: '/WinFormModern'
      preLoaderRoute: typeof WinFormModernRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/SiteHits': {
      id: '/SiteHits'
      path: '/SiteHits'
      fullPath: '/SiteHits'
      preLoaderRoute: typeof SiteHitsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/SaasScalability': {
      id: '/SaasScalability'
      path: '/SaasScalability'
      fullPath: '/SaasScalability'
      preLoaderRoute: typeof SaasScalabilityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/Portfolio': {
      id: '/Portfolio'
      path: '/Portfolio'
      fullPath: '/Portfolio'
      preLoaderRoute: typeof PortfolioRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/InfraAutomation': {
      id: '/InfraAutomation'
      path: '/InfraAutomation'
      fullPath: '/InfraAutomation'
      preLoaderRoute: typeof InfraAutomationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/Home': {
      id: '/Home'
      path: '/Home'
      fullPath: '/Home'
      preLoaderRoute: typeof HomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ErpProject': {
      id: '/ErpProject'
      path: '/ErpProject'
      fullPath: '/ErpProject'
      preLoaderRoute: typeof ErpProjectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/Blog': {
      id: '/Blog'
      path: '/Blog'
      fullPath: '/Blog'
      preLoaderRoute: typeof BlogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BlogRoute: BlogRoute,
  ErpProjectRoute: ErpProjectRoute,
  HomeRoute: HomeRoute,
  InfraAutomationRoute: InfraAutomationRoute,
  PortfolioRoute: PortfolioRoute,
  SaasScalabilityRoute: SaasScalabilityRoute,
  SiteHitsRoute: SiteHitsRoute,
  WinFormModernRoute: WinFormModernRoute,
  ZeroTrustSecurityRoute: ZeroTrustSecurityRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
